import React from "react";
import "./Rightpart.css";
import profile from "../assets/images/profile.png";
import deshboardimg from "../assets/images/deshboard-img.png";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from "react-router-dom"; //Link

export default function DashboardRight() {
  return (
    <div className="outer-div-right">
      <div className="dashbord-right-section">
        <div className="dashbord-header">
          <p className="title-dash">Dashboard</p>
          
           <div className='dropdown-section d-flex align-items-center'>
            <div className="dropdown">
              <button className="btn dropdown-toggle d-flex align-items-center gap-3" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                <div className='profile-name'>
                  <img src={profile} alt="" />
                  <div className='name-mail'>
                    <h4>DEEPAK SHARMA</h4>
                    <p>Deepak@gmail.com</p>
                  </div>
                </div>
                <ExpandMoreIcon /> 
              </button>

              <ul className="dropdown-menu ">
                <li> <Link to="/profile" className="dropdown-item">Profile</Link></li>
                <li><Link to="/support" className="dropdown-item">Support</Link></li>
                <li><Link to="/" className="dropdown-item">Logout</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="content-dashborad-outer">
          <div className="iner-boxes-dr">
            <div className="main-box-dr">
              <p>Total Order</p>
              <div className="number-iconn">
                <h4>5</h4>
                <div className="box-img-1 box-img">
                  <img src={deshboardimg} alt="" />
                </div>
              </div>
            </div>
            <div className="main-box-dr">
              <p>Total Purchase</p>
              <div className="number-iconn">
                <h4>10</h4>
                <div className="box-img-2 box-img">
                  <img src={deshboardimg} alt="" />
                </div>
              </div>
            </div>
            <div className="main-box-dr">
              <p>Cart</p>
              <div className="number-iconn">
                <h4>1</h4>
                <div className="box-img-3 box-img">
                  <img src={deshboardimg} alt="" />
                </div>
              </div>
            </div>
            <div className="main-box-dr">
              <p>Wishlist</p>
              <div className="number-iconn">
                <h4>2</h4>
                <div className="box-img-4 box-img">
                  <img src={deshboardimg} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="table-dashbord table-responsive">
            <table>
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Order Status</th>
                  <th>Date</th>
                  <th>Number of Product</th>
                  <th>Amount</th>
                  <th>View</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>Neworder#1236</td>
                  <td>
                    <span className="status placed">Placed</span>
                  </td>
                  <td>17-04-2026</td>
                  <td>2</td>
                  <td>30,000/-</td>
                  <td>
                    <VisibilityOutlinedIcon />
                  </td>
                </tr>

                <tr>
                  <td>Neworder#1236</td>
                  <td>
                    <span className="status dispatch">Dispatch</span>
                  </td>
                  <td>15-04-2026</td>
                  <td>1</td>
                  <td>10,000/-</td>
                  <td>
                    <VisibilityOutlinedIcon />
                  </td>
                </tr>

                <tr>
                  <td>Neworder#1236</td>
                  <td>
                    <span className="status packed">Packed</span>
                  </td>
                  <td>12-04-2026</td>
                  <td>3</td>
                  <td>5,000/-</td>
                  <td>
                    <VisibilityOutlinedIcon />
                  </td>
                </tr>

                <tr>
                  <td>Neworder#123</td>
                  <td>
                    <span className="status delivered">Delivered</span>
                  </td>
                  <td>18-04-2026</td>
                  <td>5</td>
                  <td>60,000/-</td>
                  <td>
                    <VisibilityOutlinedIcon />
                  </td>
                </tr>

                <tr>
                  <td>Neworder#1236</td>
                  <td>
                    <span className="status pending">Pending</span>
                  </td>
                  <td>1-04-2026</td>
                  <td>8</td>
                  <td>70,000/-</td>
                  <td>
                    <VisibilityOutlinedIcon />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
